/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Schedule_HintInputs */

const en_jobs_schedule_hint = /** @type {(inputs: Jobs_Schedule_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(cron, e.g. 0 9 * * 1 = Mondays 9am)`)
};

const he_jobs_schedule_hint = /** @type {(inputs: Jobs_Schedule_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(cron, לדוגמה 0 9 * * 1 = שני ב-9:00)`)
};

/**
* | output |
* | --- |
* | "(cron, e.g. 0 9 * * 1 = Mondays 9am)" |
*
* @param {Jobs_Schedule_HintInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_schedule_hint = /** @type {((inputs?: Jobs_Schedule_HintInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Schedule_HintInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_schedule_hint(inputs)
	return he_jobs_schedule_hint(inputs)
});